import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
function PopTeacherAssignment(props) {
  const {open, close} = props;
  const listItems = ['1. 김학생106 ㅣ생디 ㅣ 90분ㅣ 010-1234-1234', '2. 최학생203 ㅣ면접 ㅣ 60분 ㅣ 010-1234-1234', '3. 최학생203 ㅣ면접 ㅣ 60분 ㅣ 010-1234-1234', '4. 최학생203 ㅣ면접 ㅣ 60분 ㅣ 010-1234-1234', '5. 최학생203 ㅣ면접 ㅣ 60분 ㅣ 010-1234-1234', '6. 최학생203 ㅣ면접 ㅣ 60분 ㅣ 010-1234-1234'];

  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItem2, setSelectedItem2] = useState(null);
  return (
    <Modal open={open} close={close} type="pop_teacher_assignment">
      <h2 className="pop_tit">수시 교사 배정</h2>
      <div className="content_container">
        <table className="com_board_list type_row">
          <colgroup>
            <col width="120" />
            <col width="auto" />
          </colgroup>
          <tbody>
            <tr>
              <th>교실 & 시간</th>
              <td>202호 ㅣ 11:30</td>
            </tr>
            <tr>
							{/* 20250218 퍼블 수정 */}
              <th>수업 선택</th>
              <td>
                <select name="" id="" className="select">
                  <option value="김학생106 ㅣ생디 ㅣ 90분ㅣ 010-1234-1234">김학생106 ㅣ생디 ㅣ 90분ㅣ 010-1234-1234</option>
                </select>
              </td>
            </tr>
            <tr>
						{/* 20250218 퍼블 수정 */}
              <th>수업</th>
              <td className="td_point">
                1. 수업명 수업명 ㅣ 수업시간 : 90분 <br />
                2. 수업명수업명 수업시간 : 60분 <br />
                3. 수업명수업명 수업시간 : 90분 <br />총 수업회차 3회
              </td>
            </tr>
            <tr>
              <th>
                (정)
                <br />
                교사 선택
              </th>
              <td>
							<ul className="com_scroll_list pick mb_no">
                  {listItems.map((item, index) => (
                    <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => setSelectedItem(index)}>
                      <div className="check">{item}</div>
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
            <tr>
              <th>
                (부)
                <br />
                교사 선택
              </th>
              <td>
							<ul className="com_scroll_list pick mb_no">
                  {listItems.map((item, index) => (
                    <li key={index} className={`item ${selectedItem2 === index ? 'selected' : ''}`} onClick={() => setSelectedItem2(index)}>
                      <div className="check">{item}</div>
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn lightGray xs">삭제</button>
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopTeacherAssignment;
